import { useTranslation } from 'react-i18next';
import { ColorSwatchPicker } from '../../UI';
import type { ColorSwatchOption } from '../../UI';
import { TEMPLATE_COLOR_PALETTE, type TemplateColorPalette } from '../../../constants/templateColors';

interface TemplateColorPickerProps {
  strokeColor: string;
  onSelect: (colors: TemplateColorPalette) => void;
}

// The palette is keyed by its stroke colour, which doubles as the option id.
const OPTIONS: ColorSwatchOption<string>[] = TEMPLATE_COLOR_PALETTE.map((colors) => ({
  id: colors.strokeColor,
  color: colors.strokeColor,
  label: colors.strokeColor
}));

// Template-palette instance of the shared swatch picker: same control as the
// location colour, scoped to the treatment-plan template colours.
export const TemplateColorPicker = ({ strokeColor, onSelect }: TemplateColorPickerProps) => {
  const { t } = useTranslation();

  const handleSelect = (id: string) => {
    const colors = TEMPLATE_COLOR_PALETTE.find((palette) => palette.strokeColor === id);
    if (colors) onSelect(colors);
  };

  return (
    <ColorSwatchPicker
      label={t('config-iv-color')}
      options={OPTIONS}
      selectedId={strokeColor}
      onSelect={handleSelect}
    />
  );
};
